/** Reads supported public configuration without publishing unrelated environment values. */
export function getConfigurationVariable(name: string) {
  const configuration = {
    VITE_APP_AMPATH_CHAT_BOT_PHONE_NUMBER_ZA: import.meta.env
      .VITE_APP_AMPATH_CHAT_BOT_PHONE_NUMBER_ZA,
    VITE_APP_UNU_HEALTH_EVIA_TERMS_CONDITIONS_URL: import.meta.env
      .VITE_APP_UNU_HEALTH_EVIA_TERMS_CONDITIONS_URL,
    VITE_APP_UNU_HEALTH_FAQ_URI: import.meta.env.VITE_APP_UNU_HEALTH_FAQ_URI,
    VITE_APP_UNU_HEALTH_LOG_A_QUERY_ENDPOINT: import.meta.env
      .VITE_APP_UNU_HEALTH_LOG_A_QUERY_ENDPOINT,
    VITE_APP_UNU_HEALTH_PATHOLOGY_FACILITY_LINK: import.meta.env
      .VITE_APP_UNU_HEALTH_PATHOLOGY_FACILITY_LINK,
    VITE_APP_UNU_HEALTH_SUPPORT_CHAT_BOT_PHONE_NUMBER_ZA: import.meta.env
      .VITE_APP_UNU_HEALTH_SUPPORT_CHAT_BOT_PHONE_NUMBER_ZA,
    VITE_APP_UNU_HEALTH_SUPPORT_URI: import.meta.env
      .VITE_APP_UNU_HEALTH_SUPPORT_URI,
    VITE_APP_UNU_HEALTH_SUPPORT_VOICE_PHONE_NUMBER_ZA: import.meta.env
      .VITE_APP_UNU_HEALTH_SUPPORT_VOICE_PHONE_NUMBER_ZA,
    VITE_APP_UNU_HEALTH_SUPPORT_WHATSAPP_PHONE_NUMBER_ZA: import.meta.env
      .VITE_APP_UNU_HEALTH_SUPPORT_WHATSAPP_PHONE_NUMBER_ZA,
    VITE_APP_UNU_HEALTH_THIRD_PARTY_NURSE_CHAT_LINK: import.meta.env
      .VITE_APP_UNU_HEALTH_THIRD_PARTY_NURSE_CHAT_LINK,
  };
  return Object.prototype.hasOwnProperty.call(configuration, name)
    ? configuration[name as keyof typeof configuration]
    : undefined;
}
